import React from 'react';
import { Spinner } from 'react-bootstrap';

const SDGSpinner = ({ size = 'md', text = 'Loading...' }) => {
  const isLarge = size === 'lg';
  const isSmall = size === 'sm';
  
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      padding: isLarge ? '60px 40px' : isSmall ? '20px 15px' : '40px 20px',
      minHeight: isLarge ? 'calc(100vh - 120px)' : isSmall ? '120px' : '200px',
      height: isLarge ? 'calc(100vh - 120px)' : 'auto',
      width: '100%',
      background: isLarge ? '#f8f9fa' : 'transparent',
      borderRadius: isLarge ? '0' : '0',
      border: isLarge ? 'none' : 'none',
      boxShadow: isLarge ? 'none' : 'none',
      margin: '0'
    }}>
      <Spinner 
        animation="border" 
        role="status" 
        size={size}
        style={{ 
          color: '#039dda',
          width: size === 'lg' ? '3.5rem' : size === 'sm' ? '1.25rem' : '2rem',
          height: size === 'lg' ? '3.5rem' : size === 'sm' ? '1.25rem' : '2rem',
          borderWidth: size === 'lg' ? '0.3em' : size === 'sm' ? '0.2em' : '0.25em'
        }}
      >
        <span className="visually-hidden">{text}</span>
      </Spinner>
      {text && (
        <div style={{ 
          marginTop: isLarge ? '24px' : isSmall ? '12px' : '15px',
          textAlign: 'center'
        }}>
          <h4 style={{ 
            color: '#1b3e51',
            fontSize: isLarge ? '20px' : isSmall ? '14px' : '16px',
            fontWeight: 600,
            margin: '0 0 8px 0',
            letterSpacing: '-0.01em'
          }}>
            {text}
          </h4>
          {isLarge && (
            <p style={{ 
              color: '#666',
              fontSize: '0.875rem',
              margin: 0,
              fontWeight: 400
            }}>
              Please wait while we fetch the data...
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default SDGSpinner;

